module.exports = __webpack_public_path__ + "static/media/16.c87aca3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/16.jpg
// module id = 577
// module chunks = 0